import { takeEvery, takeLatest } from "redux-saga/effects";

import { applicationInitActions } from "./init/init.actions";
import { applicationInitSaga } from "./init/init.saga";
import { applicationActions } from "./application.actions";
import { saveQuoteSaga } from "./application.saga";

export function* applicationMux(): Generator<unknown, void, unknown> {
  yield takeEvery(
    applicationInitActions.initApplicationRequested,
    applicationInitSaga,
  );
  yield takeLatest(applicationActions.saveQuoteRequested, saveQuoteSaga);
}
